/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import { FETCH_DOMAIN_CLUSTER_DETAILS_REQUEST, FETCH_DOMAIN_CLUSTER_DETAILS_SUCCESS,FETCH_DOMAIN_CLUSTER_DETAILS_FAILURE } from "./DomainApproverClusterTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchDomainClusterDetailsRequest = () => {
    return {
      type: FETCH_DOMAIN_CLUSTER_DETAILS_REQUEST,
    };
  };

  export const fetchDomainClusterDetailsSuccess = (clusterData) => {
    return {
      type: FETCH_DOMAIN_CLUSTER_DETAILS_SUCCESS,
      payload: clusterData,
    };
  };

  export const fetchDomainClusterDetailsFailure = (error) => {
    return {
      type: FETCH_DOMAIN_CLUSTER_DETAILS_FAILURE,
      payload: error,
    };
  };
  
  export const fetchDomainClusterDetails = () => {
    return async function (dispatch) {
      dispatch(fetchDomainClusterDetailsRequest());
      try {
        console.log("Fetching cluster details from API...");
        const data = await APIManager.getClusters();
        console.log("Cluster API response:", data);
        dispatch(fetchDomainClusterDetailsSuccess(data));
      } catch (error) {
        console.error("Cluster API error:", error);
        dispatch(fetchDomainClusterDetailsFailure(error));
        dispatch(commonError(error,FETCH_DOMAIN_CLUSTER_DETAILS_FAILURE));
      }
    };
  };

   export const fetchPostDomainClusterDetails = (clusterData) => {
    return async function (dispatch) {
      dispatch(fetchDomainClusterDetailsRequest());
      try {
        console.log("Fetching cluster details from API...");
        const data = await APIManager.postDomainApproverClusters(clusterData);
        console.log("Cluster API response:", data);
        dispatch(fetchDomainClusterDetails());
      } catch (error) {
        console.error("Cluster API error:", error);
        dispatch(fetchDomainClusterDetailsFailure());
        dispatch(commonError(error,FETCH_DOMAIN_CLUSTER_DETAILS_FAILURE));
      }
    };
  };
  
  export const commonError=(error,errorType)=>{
    return({
      type:COMMON_ERROR,
      payload:{
        message:error.message,
        errorType:errorType
      }
    })
  }
  
